import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Form, Modal, notification } from 'antd';

import { useDefaultFormErrorNotification } from '@/hooks';

import { useUpdateWorkOrderItemTag } from '@/core/domain/workorder/WorkOrderItemTags/WorkOrderItemTags.hooks';

import CompanyWorkorderItemTagForm, {
  CompanyWorkorderItemTagFormData,
} from '../CompanyWorkorderItemTagForm';
import { WorkOrderItemTag } from '@/core/domain/workorder/WorkOrderItemTags/WorkOrderItemTags.types';

interface UpdateCompanyWorkorderItemTagModalProps {
  workOrderItemTag?: WorkOrderItemTag;
  visible: boolean;
  handleVisible: VoidFunction;
}

function UpdateCompanyWorkorderItemTagModal({
  visible,
  handleVisible,
  workOrderItemTag,
}: UpdateCompanyWorkorderItemTagModalProps) {
  const intl = useIntl();
  const { sendFormErrorNotification } = useDefaultFormErrorNotification();
  const [form] = Form.useForm<CompanyWorkorderItemTagFormData>();

  const mutation = useUpdateWorkOrderItemTag();

  useEffect(() => {
    if (visible && workOrderItemTag) {
      form.setFieldsValue({
        description: workOrderItemTag.description,
        color: workOrderItemTag.color,
      });
    }
  }, [visible, workOrderItemTag]);

  const handleOk = async () => {
    try {
      if (!workOrderItemTag) return;

      const values = await form.validateFields();

      await mutation.mutateAsync({ ...values, id: workOrderItemTag?.id });

      notification.success({
        message: intl.formatMessage({
          id: 'companies.settings.itemTags.update.notification.success',
        }),
        description: intl.formatMessage({
          id: 'companies.settings.itemTags.update.notification.success.description',
        }),
      });

      handleVisible();
    } catch (err) {
      sendFormErrorNotification(err);
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={() => handleVisible()}
      title={intl.formatMessage({ id: 'companies.settings.itemTags.update' })}
      onOk={handleOk}
      confirmLoading={mutation.isLoading}
    >
      <CompanyWorkorderItemTagForm form={form} />
    </Modal>
  );
}

export default UpdateCompanyWorkorderItemTagModal;
